// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.content-layout .actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.content-layout .actions .action-buttons {
  display: flex;
  flex-direction: row;
}
.content-layout .actions .action-buttons button {
  margin: 0 16px;
}
.content-layout .actions .action-buttons .icon-items {
  text-align: center;
}
.content-layout .tabular-view {
  width: 100%;
  display: block;
  padding: 0 0 25px !important;
  overflow: hidden;
  height: 100% !important;
}
.content-layout .tabular-view .myProjectAnddAllProjectList {
  height: 100%;
  overflow: hidden;
}
.content-layout .tabular-view .p-column-header-content {
  padding: 5px;
}
.content-layout .tabular-view .p-column-header-content .task-header-name {
  text-align: left;
}
.content-layout .tabular-view .p-column-header-content .filter-wrapper {
  display: flex;
  align-items: center;
  padding-top: 5px;
}
.content-layout .tabular-view .p-column-header-content .filter-wrapper .p-fluid.p-column-filter-element {
  min-width: 100px;
  width: 1%;
  padding-left: 5px;
  margin-right: 0.5rem;
}
.content-layout .tabular-view .card {
  border: 0 !important;
}

.p-confirm-popup {
  position: absolute;
  top: 12% !important;
  left: 0% !important;
}

.p-datepicker table td {
  padding: 0.2px !important;
}

.p-button:focus {
  box-shadow: none !important;
}

.my-task-project tr {
  position: relative;
}

.my-task-project {
  /* Limits the maximum width of task-related fields to 300px */
  /* Ensures the minimum width of remaining work fields is 95px */
  /* Similar to remaining-width, ensures a minimum width of 95px */
  /* Sets the maximum width for all task-related fields to 250px */
}
.my-task-project td,
.my-task-project th {
  max-width: 180px;
  min-width: 80px;
}
.my-task-project .task-field-width {
  max-width: 300px;
}
.my-task-project .remaining-width {
  min-width: 95px;
}
.my-task-project .all-remaining-width {
  min-width: 95px;
}
.my-task-project .all-task-field-width {
  max-width: 250px;
}
.my-task-project .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 215px);
}
.my-task-project .p-datatable-tbody {
  font-weight: 400;
}
.my-task-project td,
.my-task-project th {
  position: relative;
}
.my-task-project th:last-child:after,
.my-task-project td:last-child:after {
  content: none;
}
.my-task-project .p-datatable-thead > tr > th {
  padding: 0 1rem;
}
.my-task-project .height-70 .p-resizable-column {
  height: 70px;
}

.font-bold {
  font-weight: 700;
}

.p-checkbox {
  margin: 8px;
}
.p-checkbox .p-checkbox {
  margin: 0px;
  margin-left: 8px;
}

.p-checkbox-checked + label {
  color: #003da5;
}

.ml-2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

img[disabled] {
  opacity: 0.5;
  cursor: no-drop;
}

.clearAllFilterMainDiv {
  display: flex;
  padding: 10.56px 22px 22px 2px;
}

.clearAllFilterDiv {
  line-height: 12px;
  justify-items: end;
  display: flex;
  position: absolute;
  right: 22px;
  top: 18px;
}

.clearAllFilter {
  cursor: pointer;
}

.clearAllFilterIcon {
  cursor: pointer;
  position: absolute;
  right: 5px;
}

.sortAndFrozen {
  padding: 0 22px 22px 2px;
  cursor: pointer;
  line-height: 12px;
}

.multiSelect {
  cursor: pointer;
  line-height: 10px;
}
.multiSelect .p-placeholder {
  color: #595959 !important;
}
.multiSelect .p-multiselect {
  width: 124px !important;
}

.p-overlaypanel {
  position: absolute !important;
}

.p-multiselect-item {
  font-size: 10px !important;
  line-height: 12px !important;
  padding: 0px 9px !important;
}

.p-inputtext {
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: Montserrat !important;
}

.action-button {
  border-radius: 20px;
  box-shadow: 0 0 0 1px #003da5;
}

.p-dropdown-item:hover {
  background-color: #edf4fa !important;
}

div.actions-right {
  display: flex;
  flex-direction: row;
}
div.actions-right:nth-child(2) {
  margin-left: 12px;
}

.justify-content-center,
.justify-content-center1 {
  border: none;
}

.justify-content-center1 {
  margin-left: 15px;
}

div.p-button.p-component:nth-child(1) {
  border-radius: 12px 0 0 12px;
}

div.p-button.p-component:nth-child(2) {
  background-color: #acacac !important;
  color: white !important;
  border-radius: 0 12px 12px 0;
}

div.p-selectbutton.p-buttonset.p-component {
  border: none;
}

.p-breadcrumb a {
  text-decoration: none;
  box-sizing: border-box;
  color: #003da5;
}

.p-selectbutton .p-button.p-highlight {
  border-color: grey !important;
}

.p-selectbutton .p-button {
  border-color: grey;
}

.apply-filter-text {
  color: "#003DA5" !important;
}

.helpneeded_no,
.helpneeded_inprocess,
.helpneeded_done {
  font-size: 12px;
}

.helpneeded_no {
  color: #595959;
}

.helpneeded_done {
  color: #03a000;
}

.helpneeded_inprocess {
  color: #ff0000;
}

.helpneed_dialog {
  font-weight: bold;
}

.message_logo {
  padding-right: 2px;
}

.p-button.p-button-success {
  color: white;
  border: none;
}

.status-value {
  text-align: center;
  background-color: #e6ffe8;
  color: #006f05;
  border-radius: 4px;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
}

.On-Hold {
  background: #ffeded !important;
  color: #d30202 !important;
}

.Awaiting {
  background: #ffeded !important;
  color: #d37302;
}

.On-Hold {
  background: #ffeded !important;
  color: #d30202;
}

.Available {
  background: #faeddd !important;
  color: #d37302;
}

.In Progress {
  background: #ffeded !important;
  color: #006f05 !important;
}

.task_name {
  position: relative;
  font-size: 12px;
  color: #003da5 !important;
  text-decoration: underline;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

div.flex.align-items-center.gap-2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 10px;
}

.filter-color-change {
  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);
}

.p-overlaypanel,
.dropdown-menu,
.p-autocomplete-panel,
.p-overlaypanel,
.p-multiselect-panel,
.p-dialog-mask {
  z-index: 1000 !important;
}

.p-multiselect-panel,
.p-multiselect-items-wrapper > ul > li > span > div {
  white-space: pre-wrap;
  word-break: break-word;
}

.dropdown-menu {
  border-color: #003da5;
  box-shadow: 0px 6px 16px 0px rgba(89, 89, 89, 0.2392156863);
}

.p-autocomplete {
  box-shadow: none !important;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px solid #acacac !important;
  width: 150px;
}

.p-autocomplete-panel {
  position: absolute;
  top: 0;
  left: 0;
  overflow: auto;
  padding: 0;
  box-shadow: none !important;
  border: 1px solid #acacac;
  border-radius: 0;
}

.p-autocomplete-panel .p-autocomplete-items {
  padding: 0;
  width: 100%;
}

.p-autocomplete-items {
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-shadow: none !important;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  margin: 0;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-button-icon-only {
  background: transparent;
  color: #acacac;
  border: 0;
  height: 33px;
}

.p-button:not(button):not(a):not(.p-disabled):hover {
  background: transparent;
}

.unauthorized-user {
  text-align: center;
  font-size: 20px;
  color: red;
}

.my-task-project table {
  border-collapse: separate;
}
.my-task-project .p-datatable .p-datatable-thead tr > th {
  text-align: left;
  padding: 1rem 1rem;
  border: solid #cfcfcf;
  border-width: 1px;
  font-weight: 700;
  color: #343a40;
  background: #edf4fa;
  transition: box-shadow 0.2s;
}
.my-task-project .p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  border: solid #cfcfcf;
  border-width: 1px;
  padding: 0 1rem;
  white-space: nowrap;
}

.my-tasks-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.my-tasks-header .my-tasks-title {
  margin-top: 15px;
}

.toggle-btn .toggle-btn-todo {
  border-color: #007bff;
  font-size: 12px;
  width: 67px;
  gap: 10px;
  padding: 0.5rem 1rem 0.5rem 1rem;
  border-radius: 1.25rem 0 0 1.25rem;
  border: 0.063rem solid #003da5;
  margin-left: 1rem;
  margin-top: 1rem;
}
.toggle-btn .toggle-btn-booking {
  border-color: #007bff;
  width: 120px;
  gap: 10px;
  padding: 0.5rem 1rem 0.5rem 1rem;
  border-radius: 1.25rem 0 0 1.25rem;
  border: 0.063rem solid #003da5;
}
.toggle-btn .toggle-btn-defined {
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 12px;
  width: 113px;
  gap: 10px;
  border-color: #003da5;
  border-radius: 0 1.25rem 1.25rem 0;
  border: 0.063rem solid #003da5;
}
.toggle-btn .active {
  background-color: #003da5;
  color: #ffffff;
}
.toggle-btn .deactive {
  background-color: #ffffff;
  color: #595959;
}

.selected-row {
  background-color: #edf4fa !important;
}

.booking-breadcrumb li:first-child,
.booking-breadcrumb li:nth-child(2) {
  display: none;
}

.chart-container {
  height: 430px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}

.chart-container canvas {
  height: 100% !important;
  border: 2px solid #efefef;
  margin: 10px;
  padding-top: 50px;
  cursor: pointer;
}

.cd-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(237, 244, 250);
  padding: 0 10px;
  border: 1px solid gray;
  border-radius: 3px;
  color: #212529;
  font-weight: 400;
  min-width: 85px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tasks/TaskList/index.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAbO;EAcP,mBAAA;AAHJ;AAKI;EACE,aAAA;EACA,mBAAA;AAHN;AAKM;EACE,cAAA;AAHR;AAMM;EACE,kBAAA;AAJR;AASE;EACE,WA/BO;EAgCP,cAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAPJ;AASI;EACE,YAAA;EACA,gBAAA;AAPN;AAUI;EACE,YAAA;AARN;AAUM;EACE,gBAAA;AARR;AAWM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AATR;AAWQ;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AATV;AAcI;EACE,oBAAA;AAZN;;AAmBA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAhBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAqBA;EACE,kBAAA;AAlBF;;AAuBA;EAMC,6DAAA;EAID,+DAAA;EAIA,gEAAA;EAIA,gEAAA;AAlCA;AAiBE;;EAEE,gBAAA;EACA,eAAA;AAfJ;AAkBA;EACE,gBAAA;AAhBF;AAmBA;EACE,eAAA;AAjBF;AAoBA;EACE,eAAA;AAlBF;AAqBA;EACE,gBAAA;AAnBF;AAqBE;EACE,cAAA;EACA,WArHO;EAsHP,2BAAA;AAnBJ;AA0BE;EACE,gBA5HY;AAoGhB;AA2BE;;EAEE,kBAAA;AAzBJ;AAyCI;;EACE,aAAA;AAtCN;AA0CE;EACE,eAAA;AAxCJ;AA2CE;EACE,YAAA;AAzCJ;;AA6CA;EACE,gBAAA;AA1CF;;AAgDA;EACE,WAAA;AA7CF;AA+CE;EACE,WAAA;EACA,gBAAA;AA7CJ;;AAiDA;EACE,cAAA;AA9CF;;AAiDA;EACE,gBApLc;EAqLd,eAAA;EACA,iBAAA;AA9CF;;AAkDA;EACE,YAAA;EACA,eAAA;AA/CF;;AAqDA;EACE,aAAA;EACA,8BAAA;AAlDF;;AAqDA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAlDF;;AAqDA;EACE,eAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAlDF;;AAqDA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,iBAAA;AAlDF;AAoDE;EACE,yBAAA;AAlDJ;AAqDE;EACE,uBAAA;AAnDJ;;AAuDA;EACE,6BAAA;AApDF;;AAuDA;EACE,0BAAA;EACA,4BAAA;EACA,2BAAA;AApDF;;AAuDA;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;AApDF;;AAwDA;EACE,mBAAA;EACA,6BAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,aAAA;EACA,mBAAA;AArDF;AAuDE;EACE,iBAAA;AArDJ;;AAyDA;;EAEE,YAAA;AAtDF;;AAyDA;EACE,iBAAA;AAtDF;;AAyDA;EACE,4BAAA;AAtDF;;AAyDA;EACE,oCAAA;EACA,uBAAA;EACA,4BAAA;AAtDF;;AAyDA;EACE,YAAA;AAtDF;;AA0DE;EACE,qBAAA;EACA,sBAAA;EACA,cAAA;AAvDJ;;AA2DA;EACE,6BAAA;AAxDF;;AA2DA;EACE,kBAAA;AAxDF;;AA2DA;EACE,2BAAA;AAxDF;;AA2DA;;;EAGE,eAAA;AAxDF;;AA2DA;EACE,cAAA;AAxDF;;AA2DA;EACE,cAAA;AAxDF;;AA2DA;EACE,cAAA;AAxDF;;AA2DA;EACE,iBAAA;AAxDF;;AA2DA;EACE,kBAAA;AAxDF;;AA2DA;EACE,YAAA;EACA,YAAA;AAxDF;;AA2DA;EAEE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,yBAAA;AAzDF;;AAwEA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AArEF;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AArEF;;AAwEA;EACE,iGAAA;AArEF;;AAwEA;;;;;;EAME,wBAAA;AArEF;;AAwEA;;EAEE,qBAAA;EACA,sBAAA;AArEF;;AAwEA;EAEE,qBAAA;EACA,2DAAA;AAtEF;;AAyEA;EACE,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;AAtEF;;AAyEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AAtEF;;AAyEA;EACE,UAAA;EACA,WAAA;AAtEF;;AAyEA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,2BAAA;AAtEF;;AAyEA;EACE,SAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAtEF;;AAyEA;EACE,uBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAtEF;;AAyEA;EACE,uBAAA;AAtEF;;AAyEA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AAtEF;;AA4EE;EACE,yBAAA;AAzEJ;AAkFM;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AAhFR;AAoFI;EACE,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAlFN;;AAsFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAnFF;AAoFE;EACE,gBAAA;AAlFJ;;AAsFE;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AAnFJ;AAsFE;EACE,qBAAA;EAEA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,8BAAA;AArFJ;AAwFE;EACE,gCAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,kCAAA;EACA,8BAAA;AAtFJ;AAyFE;EACE,yBAAA;EACA,cAAA;AAvFJ;AA0FE;EACE,yBAAA;EACA,cAAA;AAxFJ;;AA4FA;EACE,oCAAA;AAzFF;;AA4FA;;EAEE,aAAA;AAzFF;;AA4FA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAzFF;;AA4FA;EAEE,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA1FF;;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA1FF","sourcesContent":["$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n\n.content-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  .actions {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: $width100;\n    align-items: center;\n\n    .action-buttons {\n      display: flex;\n      flex-direction: row;\n\n      button {\n        margin: 0 16px;\n      }\n\n      .icon-items {\n        text-align: center;\n      }\n    }\n  }\n\n  .tabular-view {\n    width: $width100;\n    display: block;\n    padding: 0 0 25px !important;\n    overflow: hidden;\n    height: 100% !important;\n\n    .myProjectAnddAllProjectList {\n      height: 100%;\n      overflow: hidden;\n    }\n\n    .p-column-header-content {\n      padding: 5px;\n\n      .task-header-name {\n        text-align: left;\n      }\n\n      .filter-wrapper {\n        display: flex;\n        align-items: center;\n        padding-top: 5px;\n\n        .p-fluid.p-column-filter-element {\n          min-width: 100px;\n          width: 1%;\n          padding-left: 5px;\n          margin-right: 0.5rem;\n        }\n      }\n    }\n\n    .card {\n      border: 0 !important;\n    }\n  }\n}\n\n\n\n.p-confirm-popup {\n  position: absolute;\n  top: 12% !important;\n  left: 0% !important;\n}\n\n// Datepicker for ProjectSetUp component Style Start\n.p-datepicker table td {\n  padding: 0.2px !important;\n}\n\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n// Datepicker for ProjectSetUp component Style End\n.my-task-project tr {\n  position: relative;\n  // border: 0 !important;\n\n}\n\n.my-task-project {\n  td,\n  th {\n    max-width: 180px;\n    min-width: 80px;\n  }\n /* Limits the maximum width of task-related fields to 300px */\n.task-field-width {\n  max-width: 300px;\n}\n/* Ensures the minimum width of remaining work fields is 95px */\n.remaining-width {\n  min-width: 95px;\n}\n/* Similar to remaining-width, ensures a minimum width of 95px */\n.all-remaining-width {\n  min-width: 95px;\n}\n/* Sets the maximum width for all task-related fields to 250px */\n.all-task-field-width {\n  max-width: 250px;\n}\n  .p-datatable>.p-datatable-wrapper {\n    overflow: auto;\n    width: $width100;\n    height: calc(100vh - 215px);\n  }\n\n  // .p-datatable-table {\n  //   line-height: 15px;\n  // }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  td,\n  th {\n    position: relative;\n\n    // &:after {\n    //   content: \"\";\n    //   display: block;\n    //   height: 22px;\n    //   width: 0.8px;\n    //   background-color: #acacac;\n    //   position: absolute;\n    //   top: 25%;\n    //   right: 0;\n    // }\n  }\n\n  th:last-child,\n  td:last-child {\n    &:after {\n      content: none;\n    }\n  }\n\n  .p-datatable-thead>tr>th {\n    padding: 0 1rem;\n  }\n\n  .height-70 .p-resizable-column {\n    height: 70px;\n  }\n}\n\n.font-bold {\n  font-weight: 700;\n}\n// .task-field-width{\n//   width: 500px;\n// }\n\n.p-checkbox {\n  margin: 8px;\n\n  .p-checkbox {\n    margin: 0px;\n    margin-left: 8px;\n  }\n}\n\n.p-checkbox-checked+label {\n  color: #003da5;\n}\n\n.ml-2 {\n  font-weight: $fontWeight400;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n// Filter and Save buttons disabled\nimg[disabled] {\n  opacity: 0.5;\n  cursor: no-drop;\n}\n\n// ProjectList Styles End\n\n// ConfirmationPopUp Styles Start\n.clearAllFilterMainDiv {\n  display: flex;\n  padding: 10.56px 22px 22px 2px;\n}\n\n.clearAllFilterDiv {\n  line-height: 12px;\n  justify-items: end;\n  display: flex;\n  position: absolute;\n  right: 22px;\n  top: 18px;\n}\n\n.clearAllFilter {\n  cursor: pointer;\n}\n\n.clearAllFilterIcon {\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n}\n\n.sortAndFrozen {\n  padding: 0 22px 22px 2px;\n  cursor: pointer;\n  line-height: 12px;\n}\n\n.multiSelect {\n  cursor: pointer;\n  line-height: 10px;\n\n  .p-placeholder {\n    color: #595959 !important;\n  }\n\n  .p-multiselect {\n    width: 124px !important;\n  }\n}\n\n.p-overlaypanel {\n  position: absolute !important;\n}\n\n.p-multiselect-item {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  padding: 0px 9px !important;\n}\n\n.p-inputtext {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-family: Montserrat !important;\n}\n\n// Container header section\n.action-button {\n  border-radius: 20px;\n  box-shadow: 0 0 0 1px #003da5;\n}\n\n.p-dropdown-item:hover {\n  background-color: #edf4fa !important;\n}\n\ndiv.actions-right {\n  display: flex;\n  flex-direction: row;\n\n  &:nth-child(2) {\n    margin-left: 12px;\n  }\n}\n\n.justify-content-center,\n.justify-content-center1 {\n  border: none;\n}\n\n.justify-content-center1 {\n  margin-left: 15px;\n}\n\ndiv.p-button.p-component:nth-child(1) {\n  border-radius: 12px 0 0 12px;\n}\n\ndiv.p-button.p-component:nth-child(2) {\n  background-color: #acacac !important;\n  color: white !important;\n  border-radius: 0 12px 12px 0;\n}\n\ndiv.p-selectbutton.p-buttonset.p-component {\n  border: none;\n}\n\n.p-breadcrumb {\n  a {\n    text-decoration: none;\n    box-sizing: border-box;\n    color: #003da5;\n  }\n}\n\n.p-selectbutton .p-button.p-highlight {\n  border-color: grey !important;\n}\n\n.p-selectbutton .p-button {\n  border-color: grey;\n}\n\n.apply-filter-text {\n  color: \"#003DA5\" !important;\n}\n\n.helpneeded_no,\n.helpneeded_inprocess,\n.helpneeded_done {\n  font-size: 12px;\n}\n\n.helpneeded_no {\n  color: #595959;\n}\n\n.helpneeded_done {\n  color: #03a000;\n}\n\n.helpneeded_inprocess {\n  color: #ff0000;\n}\n\n.helpneed_dialog {\n  font-weight: bold;\n}\n\n.message_logo {\n  padding-right: 2px;\n}\n\n.p-button.p-button-success {\n  color: white;\n  border: none;\n}\n\n.status-value {\n  // display: inline-block;\n  text-align: center;\n  background-color: #e6ffe8;\n  color: #006f05;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 4px;\n}\n\n.On-Hold {\n  background: #ffeded !important;\n  color: #d30202 !important;\n}\n\n.Awaiting {\n  background: #ffeded !important;\n  color: #d37302;\n}\n\n.On-Hold {\n  background: #ffeded !important;\n  color: #d30202;\n}\n\n.Available {\n  background: #faeddd !important;\n  color: #d37302;\n}\n\n.In Progress {\n  background: #ffeded !important;\n  color: #006f05 !important;\n}\n\n// thead.p-datatable-thead {\n//   max-height: 30px;\n// }\n\n// .p-datatable .p-datatable-thead>tr>th {\n//   background: #edf4fa;\n// }\n\n// .p-datatable-resizable-table>.p-datatable-tbody>tr>td {\n//   white-space: break-spaces;\n// }\n\n.task_name {\n  position: relative;\n  font-size: 12px;\n  color: #003da5 !important;\n  text-decoration: underline;\n  text-align: left;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: block;\n}\n\ndiv.flex.align-items-center.gap-2 {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding: 0 10px;\n}\n\n.filter-color-change {\n  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);\n}\n\n.p-overlaypanel,\n.dropdown-menu,\n.p-autocomplete-panel,\n.p-overlaypanel,\n.p-multiselect-panel,\n.p-dialog-mask {\n  z-index: 1000 !important;\n}\n\n.p-multiselect-panel,\n.p-multiselect-items-wrapper>ul>li>span>div {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dropdown-menu {\n  // width: 175px;\n  border-color: #003da5;\n  box-shadow: 0px 6px 16px 0px #5959593d;\n}\n\n.p-autocomplete {\n  box-shadow: none !important;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  border: 1px solid #acacac !important;\n  width: 150px;\n}\n\n.p-autocomplete-panel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: auto;\n  padding: 0;\n  box-shadow: none !important;\n  border: 1px solid #acacac;\n  border-radius: 0;\n}\n\n.p-autocomplete-panel .p-autocomplete-items {\n  padding: 0;\n  width: 100%;\n}\n\n.p-autocomplete-items {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  box-shadow: none !important;\n}\n\n.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {\n  margin: 0;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-button-icon-only {\n  background: transparent;\n  color: #acacac;\n  border: 0;\n  height: 33px;\n}\n\n.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: transparent;\n}\n\n.unauthorized-user {\n  text-align: center;\n  font-size: 20px;\n  color: red;\n}\n\n\n.my-task-project {\n\n  table {\n    border-collapse: separate;\n  }\n\n  // .p-datatable-resizable-table>.p-datatable-tbody>tr>td {\n  //   max-width: 500px !important;\n  // }\n\n  .p-datatable {\n    .p-datatable-thead {\n      tr>th {\n        text-align: left;\n        padding: 1rem 1rem;\n        border: solid #cfcfcf;\n        border-width: 1px;\n        font-weight: 700;\n        color: #343a40;\n        background: #edf4fa;\n        transition: box-shadow 0.2s;\n      }\n    }\n\n    .p-datatable-tbody>tr>td {\n      text-align: left;\n      border: solid #cfcfcf;\n      border-width: 1px;\n      padding:0 1rem;\n      white-space: nowrap;\n    }\n  }\n}\n.my-tasks-header {\n  display: flex;\n  align-items: center; \n  gap: 10px;\n  .my-tasks-title {\n    margin-top: 15px;\n  }\n}\n.toggle-btn {\n  .toggle-btn-todo {\n    border-color: #007bff;\n    font-size: 12px;\n    width: 67px;\n    gap: 10px;\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    border-radius: 1.25rem 0 0 1.25rem;\n    border: 0.063rem solid #003da5;\n    margin-left: 1rem;\n    margin-top: 1rem;\n  }\n\n  .toggle-btn-booking {\n    border-color: #007bff;\n    // font-size: 12px;\n    width: 120px;\n    gap: 10px;\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    border-radius: 1.25rem 0 0 1.25rem;\n    border: 0.063rem solid #003da5;\n  }\n\n  .toggle-btn-defined {\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    font-size: 12px;\n    width: 113px;\n    gap: 10px;\n    border-color: #003da5;\n    border-radius: 0 1.25rem 1.25rem 0;\n    border: 0.063rem solid #003da5;\n  }\n\n  .active {\n    background-color: #003da5;\n    color: #ffffff;\n  }\n\n  .deactive {\n    background-color: #ffffff;\n    color: #595959;\n  }\n}\n\n.selected-row {\n  background-color: #edf4fa !important;\n}\n\n.booking-breadcrumb li:first-child,\n.booking-breadcrumb li:nth-child(2) {\n  display: none;\n}\n\n.chart-container {\n  height: 430px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 12px;\n}\n\n.chart-container canvas {\n  // width: 50% !important;\n  height: 100% !important;\n  border: 2px solid #efefef;\n  margin: 10px;\n  padding-top: 50px;\n  cursor: pointer;\n}\n\n.cd-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(237 244 250);\n  padding: 0 10px;\n  border: 1px solid gray;\n  border-radius: 3px;\n  color: #212529;\n  font-weight: 400;\n  min-width: 85px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
